import { lazy } from 'react';
export var GroupPageAsync = lazy(function () { return import('./GroupPage'); });
